import { useOutletContext } from "react-router-dom";

import { BlueprintDeployment } from "types/generated";

import TemplateDeploymentStacksEmpty from "./Empty";
import TemplateDeploymentStacksTable from "./Table";

type TemplateDeploymentStacksProps = {
  deployment: BlueprintDeployment;
};

const TemplateDeploymentStacks = () => {
  const { deployment } = useOutletContext<TemplateDeploymentStacksProps>();
  if (deployment.stacks.length === 0) {
    return <TemplateDeploymentStacksEmpty />;
  }

  return <TemplateDeploymentStacksTable stacks={deployment.stacks} />;
};

export default TemplateDeploymentStacks;
